import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedUser: null
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setSelectedUser: (state, {payload}) => { state.selectedUser = payload; },
        resetUser: (state) => { state.selectedUser =  null; },
    }
});

export const {
    setSelectedUser,
    resetUser
} = userSlice.actions;

export default userSlice.reducer;